export default {
  accordion: {
    root: {
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&::before': {
        height: 0
      },
      '&$expanded': {
        marginTop: 'auto'
      }
    },
    expanded: {}
  },
  accordionSummary: {
    root: {
      '&$expanded': {
        minHeight: 'auto'
      }
    },
    content: {
      margin: 0,
      '&$expanded': {
        margin: 0
      }
    },
    expanded: {},
    expandIcon: {
      position: 'absolute',
      right: '32px',
      top: '24px'
    }
  }
}
